function n(e) {
  return e === "uHODL" || e === "sellTokenHODL";
}
export {
  n as isUHodlOrSellTokenHODL
};
//# sourceMappingURL=type.mjs.map
